import { render, staticRenderFns } from "./Callport.vue?vue&type=template&id=a17ed668&"
import script from "./Callport.vue?vue&type=script&lang=js&"
export * from "./Callport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports